import axios from "axios";
let BASE_URL = "";

const createAxiosFn = (token: any, a: any, b: any) => {
  let headerParams: any = {
    token: token,
    a: a,
    B: b,
  };
  //请求头中可能有这三个参数的任意组合，有啥传啥
  let newParams: any = {};
  for (let key in headerParams) {
    if (headerParams[key]) {
      newParams[key] = headerParams[key];
    }
  }
  let service = axios.create({
    baseURL: BASE_URL,
    timeout: 5000,
    headers: {
      "content-type": "application/json",
      currentSessionId: window.sessionStorage.getItem("currentSessionId"),
      ...newParams,
    },
  });
  // 第二步，请求拦截
  service.interceptors.request.use(
    function (config) {
      // 请求发生前处理
      return config;
    },
    function (error) {
      // 请求错误处理
      return Promise.reject(error);
    }
  );

  // 第三步，响应阻拦
  service.interceptors.response.use(
    function (response) {
      // 响应数据处理
      if (response.data.status === 10201) {
        // navigate('/login')
        alert(response.data.message);
      }
      return response.data;
    },
    function (error) {
      // 响应错误处理
      return Promise.reject(error);
    }
  );
  return service;
};
export default createAxiosFn;
